import deTranslations from "../../../../../resources/translations/translations.de.json";
import enTranslations from "../../../../../resources/translations/translations.en.json";
import { getTypedValues } from "./functions/get-typed-values.function";

export const translationKeys: typeof deTranslations | typeof enTranslations = getTypedValues(undefined, deTranslations);
